import { styled } from "@mui/material/styles";
import Button, { ButtonProps } from "@mui/material/Button";
import { useGomakeTheme } from "@/hooks/use-gomake-thme";
import { FONT_FAMILY } from "@/utils/font-family";

export interface PrimaryButtonStyledProps extends ButtonProps {}

export const StyledPrimaryButton = styled(Button)<PrimaryButtonStyledProps>((
  props,
) => {
  const { primaryColor } = useGomakeTheme();
  const primaryColorValue = primaryColor(500);
  const primaryDisabled = `var(--theme-button-bg-disabled, ${primaryColor(200)})`;

  return {
    boxShadow: "none",
    textTransform: "capitalize",
    "&[data-sentence-case]": {
      textTransform: "none",
    },
    "&[data-sentence-case] [data-button-label]": {
      textTransform: "lowercase",
      "&::first-letter": {
        textTransform: "uppercase",
      },
    },
    padding: "var(--theme-button-padding, 10px 32px)",
    lineHeight: "var(--theme-typography-label-regular-line-height, 15px)",
    height: 40,
    width: "100%",
    backgroundColor: props.variant === "contained" ? primaryColorValue : "#FFF",
    borderRadius: "var(--theme-radius-md, 4px)",
    borderColor: primaryColorValue,
    gap: 7,
    color: props.variant === "contained" ? "#FFFFFF" : primaryColorValue,
    transition: "all 0.25s ease",
    ...FONT_FAMILY.Lexend(500, 16),
    "&:hover": {
      boxShadow: "none",
    },
    "&.MuiButton-contained": {
      "&:hover": {
        backgroundColor: `var(--theme-button-bg-hover-contained, ${primaryColor(400)})`,
      },
    },
    "&.MuiButton-text": {
      backgroundColor: "inherit",
      color: primaryColorValue,
      width: "fit-content",
      "&:hover": {
        // letterSpacing: 0,
        backgroundColor: `var(--theme-button-bg-hover-text, transparent)`,
        color: `var(--theme-button-text-hover-text, ${primaryColorValue})`,
      },
    },
    "&.MuiButton-outlined": {
      backgroundColor: "inherit",
      width: "fit-content",
      "&:hover": {
        backgroundColor: `var(--theme-button-bg-hover-outlined, ${primaryColor(100)})`,
        color: `var(--theme-button-text-hover-outlined, ${primaryColorValue})`,
        borderColor: `var(--theme-button-text-hover-outlined, ${primaryColorValue})`,
      },
    },
    "&.Mui-disabled": {
      backgroundColor:
        "var(--theme-button-bg-disabled, var(--theme-primary-disabled, " +
        primaryDisabled +
        "))",
      color: "var(--theme-button-text-disabled, #FFFFFF)",
    },
  };
});
